import { connect } from 'react-redux';
import ActionResponse from './ActionResponse';

export default connect(
  null,
  null,
)(ActionResponse);
